import { Action, createReducer, on } from '@ngrx/store';
import {
  deleteCustomerRequest,
  deleteCustomerSuccess,
  deleteCustomerFailure,
  clearDeleteCustomerRequest
} from '../actions/delete-customer.actions';
import { IGenericError, ErrorResponse } from 'src/app/core/models/generic-models';

export const deleteCustomerFeatureKey = 'deleteCustomer';

export interface DeleteCustomerState {
  deleteCustomerRequest: string;
  deleteCustomerSuccess: any;
  deleteCustomerFailure: IGenericError<ErrorResponse>;
  loaded: boolean;
}

export const initialState: DeleteCustomerState = {
  deleteCustomerRequest: undefined,
  deleteCustomerSuccess: undefined,
  deleteCustomerFailure: undefined,
  loaded: undefined
};

export const reducer = createReducer(
  initialState,

  on(deleteCustomerRequest, (state, action) => ({
    ...state,
    deleteCustomerRequest: action.customerId
  })),
  on(deleteCustomerSuccess, (state, action) => ({
    ...state,
    deleteCustomerSuccess: action.response,
    loaded: true
  })),
  on(deleteCustomerFailure, (state, action) => ({
    ...state,
    deleteCustomerFailure: action.error
  })),
  on(clearDeleteCustomerRequest, (state, action) => ({
    ...state,
    deleteCustomerSuccess: undefined,
    loaded: false
  }))
);

export const deleteCustomerRequestState = (state: DeleteCustomerState) => state.deleteCustomerRequest;
export const deleteCustomerResponse = (state: DeleteCustomerState) => state.deleteCustomerSuccess;
export const deleteCustomerFailureState = (state: DeleteCustomerState) => state.deleteCustomerFailure;
export const getDeleteCustomerIsLoaded = (state: DeleteCustomerState) => state.loaded;
